import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

/**
 * Handles `save.request` actions: forwards the request to the API and
 * dispatches success/error actions.
 */
export const executeSave = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.save.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.mergeMap(([action, context]) => {
        const request = action.data
        if (!context) {
          return rxjs.of(
            feature.actions.save.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        return api.save(context, request).pipe(
          rxjs.map(response =>
            feature.actions.save.success
              .from(action)
              .create({ request, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.save.error
                .from(action)
                .create({ error, request }),
            ),
          ),
        )
      }),
    ),
)
